import AchievementCard from "./AchievementCard";
import RecentFormStrip from "./RecentFormStrip";
import PlayerRankingTimeline from "./PlayerRankingTimeline";
import styles from "../rankings.module.css";

/**
 * Ranking + achievement block for public / my-player profiles.
 */
export default function RankingProfilePanel({ ranking, showAchievements = true }) {
  if (!ranking) return null;
  const s = ranking.profileStats || {};
  return (
    <div data-testid="ranking-profile-block">
      <div className={styles.statsRow}>
        <div className={styles.stat}>
          <strong>{s.currentRanking != null ? `#${s.currentRanking}` : "—"}</strong>
          <span className={styles.muted}>Current ranking</span>
        </div>
        <div className={styles.stat}>
          <strong>{s.highestRanking != null ? `#${s.highestRanking}` : "—"}</strong>
          <span className={styles.muted}>Highest ranking</span>
        </div>
        <div className={styles.stat}>
          <strong>{s.seasonPoints ?? ranking.overall?.points ?? 0}</strong>
          <span className={styles.muted}>Season points</span>
        </div>
        <div className={styles.stat}>
          <strong>{s.careerTitles ?? 0}</strong>
          <span className={styles.muted}>Career titles</span>
        </div>
        <div className={styles.stat}>
          <strong>{s.finals ?? 0}</strong>
          <span className={styles.muted}>Finals</span>
        </div>
        <div className={styles.stat}>
          <strong>{s.winPct != null ? `${s.winPct}%` : "—"}</strong>
          <span className={styles.muted}>Win %</span>
        </div>
      </div>

      <h3 className={styles.sectionTitle}>How you&apos;re playing</h3>
      <RecentFormStrip form={s.recentForm} limit={5} />

      <h3 className={styles.sectionTitle}>Ranking timeline</h3>
      <div className={styles.panel}>
        <PlayerRankingTimeline ranking={ranking} />
      </div>

      {showAchievements ? (
        <>
          <h3 className={styles.sectionTitle}>Achievement badges</h3>
          <div className={styles.achGrid}>
            {(ranking.achievements || []).length ? (
              ranking.achievements.map((a) => <AchievementCard key={a.id} achievement={a} />)
            ) : (
              <p className={styles.muted}>Achievements unlock as you play.</p>
            )}
          </div>
        </>
      ) : null}
    </div>
  );
}
